import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import AppBar from "../components/AppBar";
import Toolbar from "../components/Toolbar";

function AppAppBar() {
  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{ flex: 1, display: "flex" }}>
            <Link
              variant="h6"
              underline="none"
              color="inherit"
              href="mailto:livingartstatuettes@gmail.com"
              sx={{ fontSize: 16 }}
            >
              livingartstatuettes@gmail.com
            </Link>
          </Box>
          <Link
            variant="h6"
            underline="none"
            color="inherit"
            href="/"
            sx={{ fontSize: 24 }}
          >
            {"Living Art Statuettes"}
          </Link>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <Link
              variant="h6"
              underline="none"
              color="inherit"
              href="https://livingartstatuettes.square.site/s/shop"
              sx={{ fontSize: 16 }}
            >
              Shop
            </Link>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default AppAppBar;
